<template>
  <div class="login-div">
    <div class="login-form ">
      <div class="disFlex">
        <div class="flex1">
          <div class="login-l-t"><img style="width: 31px;height: 31px;"
              src="@/assets/images/zhawlogol.png" /><span>智慧安卫在线课堂</span></div>
          <div><img src="@/assets/images/login_bg.png" /></div>
        </div>
        <div class="flex1">
          <div class="login-r-t1">欢迎登录</div>
          <div class="login-r-t2"> </div>
          <el-form ref="form" class="loginForm" :model="form" :rules="rules" label-width="70px" style="width: 310px;"
            v-if="itype=='1'">
            <el-form-item label="账号" prop="loginName">
              <el-input v-model="form.loginName" placeholder="请输入登录账号" @keyup.enter.native="inputChange"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password">
              <input type="text" class="hidden" />
              <input type="password" class="hidden" />
              <el-input show-password v-model="form.password" placeholder="请输入登录密码" @keyup.enter.native="inputChange">
              </el-input>
            </el-form-item>
            <el-form-item label="验证码" prop="check_key" style="margin-bottom: 10px;">
              <el-input v-model="form.check_key" placeholder="请输入验证码" @keyup.enter.native="inputChange">
                <img :src="yzmImg" @click="getImgYzm()" slot="append"
                  style="width: 80px;height: 34px;padding-right: 3px;" />
              </el-input>
            </el-form-item>
            <div class="disFlex between" style="font-size: 14px;margin-bottom: 20px;">
              <span style="color: #0071BA;cursor: pointer;" @click="changeItype(2)">手机验证码登录</span>
              <span style="color:#606266">客服电话:13137703753</span>
            </div>
            <el-button type="primary" style="width: 100%;" @click="onSubmit">登录</el-button>
          </el-form>
          <el-form ref="phoneform" class="loginForm" :model="phoneform" :rules="phonerules" label-width="0px"
            style="width: 310px;" v-if="itype=='2'">
            <el-form-item label="" prop="loginName">
              <el-input v-model="phoneform.loginName" placeholder="请输入手机号" @keyup.enter.native="inputChange"></el-input>
            </el-form-item>
            <el-form-item label="" prop="check_key">
              <el-input v-model="phoneform.check_key" placeholder="请输入验证码" @keyup.enter.native="inputChange">
                <img :src="yzmImg" @click="getImgCode()" slot="append" style="width: 80px;height: 34px;" />
              </el-input>
            </el-form-item>
            <el-form-item label="" prop="code">
              <el-input v-model="phoneform.code" placeholder="请输入手机验证码" @keyup.enter.native="inputChange">
                <span slot="append" style="padding-right: 10px;cursor: pointer;"
                  @click="getYzm()">{{isDjs?djsTime+'s':'获取验证码'}}</span>
              </el-input>
            </el-form-item>
            <div class="disFlex between" style="font-size: 14px;margin-bottom: 20px;">
              <span style="color: #0071BA;cursor: pointer;" @click="changeItype(1)">账号密码登录</span>
              <span style="color:#606266;">客服电话:13137703753</span>
            </div>
            <el-button type="primary" style="width: 100%;" @click="onSubmitPhone">登录</el-button>
          </el-form>

          <div
            style="width: 310px;font-size: 16px;color: #0071ba;margin-top: 25px;display: flex;justify-content: space-between;">
            <!-- <div></div> -->
            <!-- <div><span style="cursor: pointer;" @click="toHome">首页</span></div> -->
            <!-- <div><span style="cursor: pointer;" @click="toRegist">注册账号 ></span></div> -->
          </div>
        </div>
      </div>
      <div class="zhushou">
        <a href="http://www.tsanquan.com" target="_blank">安全助手</a>
        <a href="http://www.gtzyws.com" target="_blank">职业健康助手</a>
      </div>
    </div>
    <div class="login-bt-bg">
      <p>河南天顺信息技术有限公司</p>
      <p> 地址：河南省郑州市二七区嵩山路街道航海中路河南省交通科研院十一层1103 Tel: 131 3770 3753</p>
      <p> 邮箱：zhihuianwei@163.com 公众号：智慧安卫云</p>
      <p>© Copyright © 2022 - 2030 河南天顺信息技术有限公司 <a href="https://beian.miit.gov.cn/" style="padding-left: 5px;color: #fff;text-decoration: underline;">豫ICP备19026038号-1</a></p>
    </div>
  </div>
</template>

<script>
  let id = 0;
  var djsTimerInt = null;
  export default {
    name: 'Login',
    data() {
      var validatePhone = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('手机号不能为空！'));
        } else if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(value))) {
          callback(new Error('联系方式有误，请重新输入！'));
        } else {
          callback();
        }
      };
      var $this = this;

      return {
        itype: '1',
        djsTime: 60,
        isDjs: false,
        form: {
          loginDevice: '1',
          loginName: '',
          password: '',
          account: '',
          check_key: '',
          passwordText: '',
          sid: '16'
        },
        phoneform: {
          loginName: '',
          type: 'phone',
          check_key: '',
          code: '',
          account: ''
        },
        yzmImg: '/safety/get_check_key.htm?v=' + Math.random(),
        props: {
          lazy: true,
          lazyLoad(node, resolve) {
            const {
              level,
              value
            } = node;
            var loadUrl = '/system/district/tree2.htm'
            if (value) {
              loadUrl += '?parentId=' + value;
            }
            $this.$axios.get(loadUrl).then(res => {
              var data = res.data;
              const nodes = data.map(item => ({
                value: item.id,
                label: item.text,
                leaf: !item.isParent
              }));
              resolve(nodes);
            })
          },
        },
        rules: {
          loginName: [{
            required: true,
            message: '请输入账号',
            trigger: 'blur'
          }],
          password: [{
            required: true,
            message: '请输入密码',
            trigger: 'blur'
          }],
          check_key: [{
            required: true,
            message: '请输入图片验证码',
            trigger: 'blur'
          }]
        },
        phonerules: {
          loginName: [{
            validator: validatePhone,
            trigger: 'blur'
          }],
          code: [{
            required: true,
            message: '请输入手机验证码',
            trigger: 'blur'
          }],
          check_key: [{
            required: true,
            message: '请输入图片验证码',
            trigger: 'blur'
          }]
        },
      }
    },
    methods: {
      changeItype: function(itype) {
        this.itype = itype
      },
      // 跳转注册页面
      toRegist: function() {
        this.$router.push('/Register');
      },
      getImgYzm: function() {
        this.yzmImg = '/safety/get_check_key.htm?v=' + Math.random();
      },
      onSubmit: function() {
        this.$refs['form'].validate((valid) => {
          var $this = this;
          if (valid) {
            this.form.account = this.form.loginName;
            var str = '';
            for (var i = 0; i < this.form.password.length; i++) {
              str += '●';
            }
            this.form.passwordText = str;
            this.$axios.post('/j_spring_security_check', this.$qs.stringify(this.form), {
              headers: {
                "X-Requested-With": "XMLHttpRequest",
              }
            }).then(res => {
              var data = res.data;
              if (data.stat == '1') {
                var websites = data.data.websites;
                var iscz = false;
                for (var i = 0; i < websites.length; i++) {
                  if (websites[i].sid == '16') {
                    iscz = true;
                  }
                }
                if (iscz) {
                  if (this.$route.query.productId) {
                    this.$router.push('/ProductDetail?id=' + this.$route.query.productId);
                  } else {
                    this.$router.push('/Learning');
                  }
                } else {
                  this.loginOut();
                  this.$message.warning("您还没有开通该平台权限，请联系客服管理员！");
                }
              } else {
                this.$message.error(data.message);
                this.isDenglu = false;
                this.getImgYzm();
              }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      // 获取手机号验证码
      getYzm: function() {
        var check_key = this.phoneform.check_key;
        var phone = this.phoneform.loginName;
        if (this.isDjs) {
          return;
        }
        if (check_key) {
          if (!(/^[1][3,4,5,7,8][0-9]{9}$/.test(phone))) {
            this.$message.error('手机号码有误，请确认手机号码！');
            return;
          }
          this.$axios.get('/get_checkvalid_key.htm?check_key=' + check_key, {
            headers: {
              "X-Requested-With": "XMLHttpRequest",
            }
          }).then(res => {
            var data = res.data;
            if (data.codeStatus == '1') {
              // 图片验证码验证通过  向用户推送短信
              this.sendMsg(phone);
            } else {
              this.$message.error('请输入正确的图片验证码！');
            }
          })
        } else {
          this.$message.error('请先输入图片验证码！')
          return;
        }
      },
      sendMsg: function(phone) {
        this.djsTime = 60;
        this.isDjs = true;
        var $this = this;
        djsTimerInt = setInterval(function() {
          $this.djsTime = $this.djsTime - 1;
          if ($this.djsTime == 0) {
            $this.djsTime = 60;
            $this.isDjs = false
            clearInterval(djsTimerInt);
            djsTimerInt = null;
          }
        }, 1000);
        this.$axios.post('/prevention/sysEntInfo/sendPCode2.htm', this.$qs.stringify({
          phone: phone
        }), {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          }
        }).then(res => {
          var data = res.data;
          if (data.stat == '1') {
            this.$message.success('短信发送成功，请注意查收！');
          } else {
            this.$message.error(data.message);
          }
        })
      },
      //
      getImgCode: function() {
        this.yzmImg = '/get_check_key.htm?v=' + Math.random();
      },
      onSubmitPhone: function() {
        localStorage.clear('currentUser');
        this.$refs['phoneform'].validate((valid) => {
          var $this = this;
          if (valid) {
            this.phoneform.account = this.phoneform.loginName;
            this.$axios.post('/j_spring_security_check', this.$qs.stringify(this.phoneform), {
              headers: {
                "X-Requested-With": "XMLHttpRequest",
              }
            }).then(res => {
              var data = res.data;
              if (data.stat == '1') {
                this.$message({
                  message: '登录成功',
                  type: 'success'
                });
                this.$router.push('/Home')
              } else {
                this.$message.error(data.message);
              }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      inputChange: function() {
        if (this.itype == '1') {
          this.onSubmit();
        } else {
          this.onSubmitPhone();
        }
      },
      loginOut: function() {
        this.$axios.get('/j_spring_security_logout?sys=hse', {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          }
        }).then(res => {})
      },
      toHome: function() {
        this.$router.push('/Home')
      }
    }
  }
</script>

<style>
  .login-div {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    background-color: #0071BA;
  }

  .login-form {
    width: 815px;
    height: 471px;
    background: #ffffff;
    border-radius: 6px;
    box-shadow: 0px 2px 34px 0px #025a93;
    position: absolute;
    left: 50%;
    top: 50%;
    margin: -236px 0 0 -408px;
  }

  .hidden {
    width: 0;
    height: 0;
    border-width: 0 !important;
    position: absolute;
  }

  .login-l-t {
    padding: 24px 0 29px 45px;
    font-size: 20px;
    font-family: 'SourceHanSansCN, SourceHanSansCN-Bold';
    font-weight: 700;
    color: #025a93;
    line-height: 30px;
    letter-spacing: 1px;
    text-align: left;
  }

  .login-l-t span {
    padding-left: 12px;
  }

  .login-r-t1 {
    font-size: 24px;
    font-family: ' PingFangSC';
    font-weight: 500;
    text-align: left;
    color: #333333;
    line-height: 24px;
    padding-top: 30px;
  }

  .login-r-t2 {
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 400;
    text-align: left;
    color: #9a9a9a;
    line-height: 24px;
    padding-top: 8px;
    margin-bottom: 20px;
  }

  .login-bt-bg {
    background: url(../assets/images/ldbg.png) 0 0 no-repeat;
    background-size: 100% 100%;
    height: 22vh;
    position: absolute;
    bottom: 0;
    width: 100vw;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #eee;
  }

  .login-bt-bg p {
    margin: 5px;
  }

  .loginForm .el-form-item {
    width: 310px;
    height: 44px;
    opacity: 1;
    border: 1px solid #d9d9d9;
    border-radius: 3px;
    line-height: 44px;
  }

  .loginForm .el-form-item--medium .el-form-item__label {
    height: 44px;
    line-height: 44px;
  }

  .loginForm .el-input--medium .el-input__inner {
    border: none;
    height: 44px;
    line-height: 44px;
  }

  .loginForm .el-input-group__append {
    background-color: #fff;
    padding: 0;
    border: none;
  }

  .loginForm .el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap>.el-form-item__label:before,
  .loginForm .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
    display: none;
  }

  .zhushou{
    padding: 20px;
    font-size: 13px;
  }
  .zhushou a{
    color: #0071ba;
    text-decoration: underline;
    padding: 0 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue